import { render, staticRenderFns } from "./WorkOrderDetails.vue?vue&type=template&id=72b76dbb&scoped=true"
import script from "./WorkOrderDetails.vue?vue&type=script&lang=ts"
export * from "./WorkOrderDetails.vue?vue&type=script&lang=ts"
import style0 from "./WorkOrderDetails.vue?vue&type=style&index=0&id=72b76dbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b76dbb",
  null
  
)

export default component.exports